import { render, staticRenderFns } from "./TalkUpload.vue?vue&type=template&id=473e967d&scoped=true&"
import script from "./TalkUpload.vue?vue&type=script&lang=ts&"
export * from "./TalkUpload.vue?vue&type=script&lang=ts&"
import style0 from "./TalkUpload.vue?vue&type=style&index=0&id=473e967d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473e967d",
  null
  
)

export default component.exports